import React from "react";
import { Navigate } from "react-router-dom";

export default function Resolve() {

  // Otherwise go to the login form
  return <Navigate replace to="login" />;
}
